import { tblMap } from './tblMap';

export class ClientMap{
    public ID:number=0;
    public ClientID:number=0;
    public MapID:number=0;
    public IsActive :boolean=false;
    public Map = new tblMap();
}